
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VaccineBrandDetApi } from '../api/vaccinebranddet.api';
import { switchMap, map } from 'rxjs/operators';
import { VaccineBrandDetData, VaccineBrandDet } from '../../../interfaces/masters/vaccine_branddet' ;

@Injectable()
export class VaccineBrandDetService extends VaccineBrandDetData {

    constructor(private api: VaccineBrandDetApi) {
      super();
    }
  
  
    list(url: string): Observable<VaccineBrandDet[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<VaccineBrandDet>{
        return this.api.getById(url);
    }
  
    create(url: string, data:VaccineBrandDet): Observable<VaccineBrandDet[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:VaccineBrandDet): Observable<VaccineBrandDet> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  